import script from "./RedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RedButton.vue?vue&type=script&setup=true&lang=js"

import "./RedButton.vue?vue&type=style&index=0&id=d29b6958&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/blue-jays-ticketfinder/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d29b6958"]])

export default __exports__